module.exports = __webpack_public_path__ + "static/media/Jest.9edcb510.png";